import NidApp from "./api";

/**
 * All service booking things here
 */

(function ($, nordsjo) {
	$(function () {
		var $selectedStore = $('.selected-store')
		var $bookingForm = $('#booking-form')
		/**
		 * Opens store picker
		 */
		$selectedStore
			.on('click', '.service-booking', function (e) {
				e.preventDefault();
				nordsjo.showStorePicker('service-booking');
			});

		/**
		 * Listen to form inputs and validate
		 */
		$bookingForm
			.on('change', 'input', function (e) {
				$(e.target).addClass('entered');
				validateBookingForm();
			});

		$($bookingForm).on('submit', function (e) {
			e.preventDefault();
			var form = this
			$.ajax({
				type: 'POST',
				url: nordsjo.ajaxurl,
				data: {
					'action': 'nid_submit_booking',
					'form': $(form).serialize(),
					'security': nordsjo.ajaxNonce
				}
			}).done(function (response) {
				var message = response.data.message;
				form.reset()
				$('.thank-you-message').show();
				NidApp.showMessage(message);
			});
		});

		function validateBookingForm() {
			var submitButton = $('#submit-booking');
			var $name = $('#booking-user-name', $bookingForm);
			var $email = $('#booking-user-email', $bookingForm);
			var $phone = $('#booking-user-phone', $bookingForm);
			var $terms = $('#agreed-to-terms', $bookingForm);
			var valid = true;
			var validEmail = true;

			if ($name.val() === '' && $name.hasClass('entered')) {
				valid = false;
				$name.addClass('invalid');
			} else {
				$name.removeClass('invalid');
			}

			if ($email.val() === '' && $email.hasClass('entered')) {
				valid = false;
				$email.addClass('invalid');
			} else {
				$email.removeClass('invalid');
			}

			if ($phone.val() === '' && $phone.hasClass('entered')) {
				valid = false;
				$phone.addClass('invalid');
			} else if ($phone.val() === '') {
				valid = false;
			} else {
				$phone.removeClass('invalid');
			}

			if (validateEmail($email.val()) === false) {
				validEmail = false;
				valid = false;
			}

			if ($terms.prop('checked') === false) {
				valid = false;
			}

			if (false === validEmail) {
				$email.addClass('invalid');
			} else {
				$email.removeClass('invalid');
			}

			if (true === valid) {
				submitButton.prop('disabled', false);
			} else {
				submitButton.prop('disabled', true);
			}
		}

		function validateEmail($email) {
			var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			return emailReg.test($email);
		}

	});
}(jQuery, nordsjo));
